import { render, staticRenderFns } from "./scatterEchart.vue?vue&type=template&id=5ddf5687&scoped=true&"
import script from "./scatterEchart.vue?vue&type=script&lang=js&"
export * from "./scatterEchart.vue?vue&type=script&lang=js&"
import style0 from "./scatterEchart.vue?vue&type=style&index=0&id=5ddf5687&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddf5687",
  null
  
)

export default component.exports